<script setup lang="ts">
  import { computed } from "vue";
  import { Badge } from "@/components/ui/badge";
  import { Tooltip } from "@/components/ui/tooltip";
  import type { ChatPageAccount } from "@/types";

  const VISIBLE_COUNT = 3;

  const props = defineProps<{ accounts?: ChatPageAccount[] }>();

  // The default account is named first: it is the one every `p`-less link resolves to.
  const sortedAccounts = computed(() =>
    [...(props.accounts ?? [])].sort((a, b) => Number(b.is_default) - Number(a.is_default)),
  );
  const names = computed(() => sortedAccounts.value.map((account) => account.name));
  const visibleAccounts = computed(() => sortedAccounts.value.slice(0, VISIBLE_COUNT));
  const hiddenNames = computed(() => names.value.slice(VISIBLE_COUNT));
</script>

<template>
  <span v-if="!names.length">-</span>

  <div
    v-else
    class="flex items-center gap-1.5">
    <span class="flex min-w-0 items-center">
      <template
        v-for="(account, index) in visibleAccounts"
        :key="account.id">
        <span
          v-if="index"
          class="mr-1">
          ,
        </span>
        <span class="min-w-0 truncate">{{ account.name }}</span>
        <Badge
          v-if="account.is_default"
          variant="secondary"
          class="ml-1 shrink-0 px-1.5 py-0 text-3xs font-medium">
          Default
        </Badge>
      </template>
    </span>

    <Tooltip
      v-if="hiddenNames.length"
      :content="hiddenNames.join(', ')">
      <Badge
        variant="secondary"
        class="shrink-0 px-1.5 py-0 text-3xs font-medium">
        +{{ hiddenNames.length }}
      </Badge>
    </Tooltip>
  </div>
</template>
